module.exports = __webpack_public_path__ + "img/calendar2-event.4f9e3cb9.svg";